export const environment = {
  production: false,
  SERVER: "http://localhost:4227/",
  // SERVER: "https://dialer.gventure.us:4751/",
  // report_server: "https://dialer.gventure.us:4751/",
  report_server: "http://localhost:3000/",

  // Reports API URLs
  reports_api_url: "http://localhost:3000/",
    reports_endpoints: {
      all_reports:              "getallreports",
      agent_reports:            "getallagentsreports",
      call_termination_reports: "getallcallterminationreports",
      call_center_reports:      "getallcallcenterreports",
      skill_group_reports:      "getallskillgroupreports",
      ivr_reports:              "getallivrreports",
      live_reports:             "getlivereports",
      report_options:           "rptoption",
      agent_group_list:         "predictive/agentopt",
      reports_manager:          "custom/reports_manager",
    },
  secret_key: 'sk_test_51MqLi2IfUajqCsLP6Zyp7hu6MODLiScWOMCiEZMF951NicJzhkdISqkCb9s5NmuaOrOcAkjIypS7rQ1AifGBv2eq00iAseCFRY',
  public_key: 'pk_test_51MqLi2IfUajqCsLPglFizTZGWNHAAoHtX2wyeh7XaJxJZKZ7jfhev8KFPA4iFJ5o1IYmqBccls6xRfwXDgqlOrZd00ddzzJFid',
  SERVERURL: "http://localhost:3000/",
  CUSTOMERURL: 'http://localhost:4300/',
  cental_url: 'https://dialer.gventure.info/',

  // Dialer Reports Module
  dialer_reports: {
    server: 'http://localhost:3000/',
    // server:   'https://websocket.gventure.us/reportapi/',
    endpoints: {
      table: 'custom/reports_manager?type=tabular',
      graph: 'custom/reports_manager?type=graph',
      widgets: 'custom/reports_manager?type=widgets',
    }
  }
  // CISERVER: "http://localhost/flowroute/index.php/",
  // STRIPEKEY: "pk_test_d0HlS1Sj71gqj74d9kArjGAS00EoWoUsC8",
  // WEBSOCKET: "https://auxcall.crmdialer.us/api/",
  // RECORDRURL: "https://localhost/recording/",
  // DEFAULT: "http://localhost:4227/uploads/file/demo1.png",
  // MAINSERVER: "http://localhost:4200/",
  // sipURI: "csagents.smarteco.us",
  // SAVE_AUDIO_API:"http://localhost:4227/saveAudio/"   
  // ,Audio_Path:"/assets/audio"
};